<template>
  <article
    data-reveal-item
    class="group flex flex-col rounded-lg border p-4 backdrop-blur-md transition-all"
    :class="
      project.featured
        ? 'border-[#7b2ff7] hover:shadow-[0_0_28px_-6px_#7b2ff7]'
        : 'border-[var(--border)] bg-[var(--surface)] hover:border-[var(--accent)] hover:shadow-[0_0_22px_-8px_var(--accent)]'
    "
    :style="project.featured && project.accent ? { background: project.accent } : undefined"
  >
    <div class="flex items-center gap-3">
      <span
        v-if="project.featured"
        class="grid h-8 w-8 shrink-0 place-items-center rounded bg-[#7b2ff7] font-mono text-sm font-bold text-white"
        aria-hidden="true"
      >
        {{ project.title.charAt(0).toUpperCase() }}
      </span>
      <img
        v-else
        :src="project.img"
        :alt="project.title"
        class="h-8 w-8 shrink-0 object-contain"
        loading="lazy"
      />
      <h3
        class="min-w-0 flex-1 truncate font-mono text-sm"
        :class="project.featured ? 'text-white' : 'text-[var(--accent)]'"
      >
        {{ project.title }}
      </h3>
      <span
        v-if="project.featured && project.status"
        class="flex items-center gap-1 rounded px-1.5 py-0.5 font-mono text-[10px] uppercase text-white"
        style="background: #7b2ff7"
      >
        <span class="inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-white" aria-hidden="true" />
        {{ loc(project.status) }}
      </span>
      <span
        v-else-if="project.isNew"
        class="rounded bg-[var(--accent)] px-1.5 py-0.5 font-mono text-[10px] uppercase text-[var(--bg)]"
      >
        {{ t('projects.new') }}
      </span>
    </div>
    <p
      class="mt-2 flex-1 text-sm"
      :class="project.featured ? 'text-white/85' : 'text-[var(--muted)]'"
    >
      {{ loc(project.description) }}
    </p>
    <ul class="mt-3 flex flex-wrap gap-1.5">
      <li
        v-for="tag in project.tags"
        :key="tag"
        class="rounded border px-1.5 py-0.5 font-mono text-[11px]"
        :class="
          project.featured
            ? 'border-white/25 text-white/80'
            : 'border-[var(--border)] text-[var(--muted)]'
        "
      >
        {{ tag }}
      </li>
    </ul>
    <div class="mt-3 flex gap-3 font-mono text-xs">
      <a
        v-if="project.repository"
        :href="project.repository"
        target="_blank"
        rel="noopener noreferrer"
        :class="project.featured ? 'text-white/70 hover:text-white' : 'text-[var(--muted)] hover:text-[var(--accent)]'"
        class="transition-colors"
      >
        {{ t('projects.repo') }} →
      </a>
      <a
        v-if="project.url"
        :href="project.url"
        target="_blank"
        rel="noopener noreferrer"
        :class="project.featured ? 'text-white hover:underline' : 'text-[var(--muted)] hover:text-[var(--accent)]'"
        class="font-bold transition-colors"
      >
        {{ t('projects.live') }} →
      </a>
    </div>
  </article>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { loc, type ProjectItem } from '../data'

defineProps<{ project: ProjectItem }>()
const { t } = useI18n()
</script>
